import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ConnectionType } from '../../../../../../../../api/connections.dao';
import { UniqueJoiningLinkOptionsButton } from './unique-joining-link-options';
import { KnoviodOptionsButton } from './knovio-options-btn';
import { IButtonOption } from '../../../../../../../global/options-button/options-button';
import { MORE_BUTTON_TEXT } from '../../../../../../../../constants/common-labels.constants';

export interface IConnectionFormFooterOptionsButtonProps {
    connectionType: ConnectionType;
    shouldRender: boolean;
    knovioConnectionMoreOptions: IButtonOption[];
    onDeleteConnectionAction: () => void;
}

const ConnectionFormFooterOptionsButton: React.FC<IConnectionFormFooterOptionsButtonProps> = ({
    connectionType,
    shouldRender,
    knovioConnectionMoreOptions,
    onDeleteConnectionAction
}) => {
    const formattedMessageLabel: JSX.Element = (
        <FormattedMessage {...MORE_BUTTON_TEXT} />
    );

    if (!shouldRender) {
        return null;
    }

    switch (connectionType) {
        case ConnectionType.UniqueJoiningLink:
            return <UniqueJoiningLinkOptionsButton label={formattedMessageLabel} onDeleteConnectionAction={onDeleteConnectionAction} />;
        case ConnectionType.Knovio:
            return <KnoviodOptionsButton label={formattedMessageLabel} options={knovioConnectionMoreOptions} />;
        default:
            return null;
    }
};

export { ConnectionFormFooterOptionsButton };
